import React, { useState } from "react";
import {
	Paper,
	Container,
	Typography,
	TextField,
  makeStyles,
  Theme,
} from "@material-ui/core/";

import { Link, Redirect } from "react-router-dom";
import { useStore } from "../../store/StoreProvider";
import { TRegistrationForm } from "../../store/Types";
import { observer } from "mobx-react";
import CustomButton from "../../shared/Button";

const useFormStyles = makeStyles((theme: Theme) => ({
	paper: {
		padding: "48px 0",
    width: "520px",
    borderRadius: '20px',
    [theme.breakpoints.down('xs')]: {
      borderRadius: '0',
      width: '100%'
    }
	},
	formContainer: {
    padding: "0 102px 0 98px",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '0 16px'
    }
  },
  fieldsWrapper: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  fieldsDivider: {
    minWidth: '8px'
  },
  form: {
    marginBottom: '24px'
  },
	buttonContainer: {
		display: "flex",
		justifyContent: "flex-end",
		marginTop: "30px"
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '2.75rem',
    fontSize: '1.65rem'
  },
  btn: {
    marginTop: '72px'
  }
}));

const RegistrationForm = props => {
  const store = useStore();
	const [userInfo, setUserInfo] = useState<TRegistrationForm>({
		email: "",
		password: "",
		name: "",
		surname: ""
	});
	const onSubmit = (event: React.FormEvent) => {
		event.preventDefault();
		store.registration(userInfo);
	};

	const onInputChange = event => {
		let input = event.target;
		setUserInfo({ ...userInfo, [input.name]: input.value });
	};

	const classes = useFormStyles();

	if (store.isLoggedIn) {
		return <Redirect to="/main" />;
	}

	return (
		<Paper className={classes.paper}>
			<Container className={classes.formContainer}>
				<Typography variant="h4" className={classes.title}>
					Регистрация
				</Typography>
				<form onSubmit={onSubmit} className={classes.form}>
          <TextField
            label="Адрес электронной почты"
            type="email"
            name="email"
            value={userInfo.email}
            onChange={onInputChange}
            inputProps={{ "data-testid": "inputEmail" }}
            margin="normal"
            fullWidth
            required
          />
          <div className={classes.fieldsWrapper}>
            <TextField
              label="Имя"
              type="text"
              name="name"
              value={userInfo.name}
              onChange={onInputChange}
              inputProps={{ "data-testid": "inputName" }}
              margin="normal"
              fullWidth
              required
            />
            <div className={classes.fieldsDivider} />
            <TextField
              label="Фамилия"
              type="text"
              name="surname"
              value={userInfo.surname}
              onChange={onInputChange}
              inputProps={{ "data-testid": "inputSurname" }}
              margin="normal"
              fullWidth
              required
            />
          </div>
          <TextField
            label="Пароль"
            type="password"
            name="password"
            value={userInfo.password}
            onChange={onInputChange}
            inputProps={{ "data-testid": "inputPassword" }}
            margin="normal"
            fullWidth
            required
          />
          <CustomButton fullWidth type="submit" classname={classes.btn}>
            Зарегистрироваться
          </CustomButton>
				</form>
        <div>
					<Typography>
						Уже зарегистрирован?{" "}
						<Link to="/login" style={{ textDecoration: 'none', color: '#FDBF5A' }}>
							Войти
						</Link>
					</Typography>
				</div>
			</Container>
		</Paper>
	);
};

export default observer(RegistrationForm);
